// sorting
export const SORTING_COLUMN_NAME = {
    Cheapest: "listPriceValue",
    Fastest: "totalTimeDuration",
    Best: "",
} as const;

export type SortingOption = keyof typeof SORTING_COLUMN_NAME;

// --------------------------------------------------

// domestic return mapping
export const DOMESTIC_RETURN_TYPE_MAP = {
    ReturnDomesticOutBound: "OutBound",
    ReturnDomesticInBound: "InBound",
} as const;

export type ReturnDomesticType = keyof typeof DOMESTIC_RETURN_TYPE_MAP;
export type BoundType =
    typeof DOMESTIC_RETURN_TYPE_MAP[ReturnDomesticType];

export type SelectedReturnDomestic = Record<BoundType, any>;

// --------------------------------------------------

// flight journey
export const FLIGHT_JOURNEY_TYPE = {
    OneWayBoth: "OneWayBoth",
    ReturnInternational: "ReturnInternational",
    ReturnDomesticOutBound: "ReturnDomesticOutBound",
    ReturnDomesticInBound: "ReturnDomesticInBound",
    MultiCityBoth: "MultiCityBoth",
    ReturnDomesticBoth: "ReturnDomesticBoth",
} as const;

export type FlightJourneyType =
    keyof typeof FLIGHT_JOURNEY_TYPE;


// --------------------------------------------------

// more fare
export type MoreFareSelectedItem = {
    id: string;
    index: number;
    moreFare: any; // improve later if possible
    flightJourneyType: FlightJourneyType;
};